export enum ReportAnswer {
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    E = "E",
};
